import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lib-auth-card',
  imports: [],
  template: `<div class="form-area">
    <ng-content select="[alternate]" />

    <div class="form-content">
      <div class="logo-container">
        <img
          src="assets/logos/vicgov-logos/Vic-Logo-small-alt.svg"
          alt="LASSI Logo"
        />
        <span class="mat-title-medium"> LASSI </span>
      </div>
      <ng-content />
    </div>
  </div> `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    .form-area {
      width: min(600px, calc(100vw - 2rem));
    }

    .form-content {
      background: mat.get-theme-color(theme.$light-theme, on-primary);
      border-radius: 0.5rem;
      border: 1px solid
        mat.get-theme-color(theme.$light-theme, on-surface-variant);
      padding: 2rem;

      .logo-container {
        margin-bottom: 1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        > span {
          font-weight: bold;
          color: mat.get-theme-color(theme.$light-theme, on-primary-fixed);
        }
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthCardComponent {}
